export const SET_ORDERS = "SET_ORDERS";
export const CLEAR_STATE = "CLEAR_STATE";
export const SET_ORDERS_OWNER_KEY = "SET_ORDERS_OWNER_KEY";
export const SET_ORDERS_SCROLL_TOP = "SET_ORDERS_SCROLL_TOP";
export const SET_ORDERS_FILTERS = "SET_ORDERS_FILTERS";
export const SET_LIMIT_REACHED = "SET_LIMIT_REACHED";

export const DEFAULT_ORDERS_FILTERS = {
	page: 1,
};
